
(function() {
        const path = window.location.pathname;
     if (
          path === "/products/classic-bokksu" ||
          path === "/products/gift-classic-bokksu" ||
          path === "/products/gift-card" ||
          path === "/products/bokksu-corporate-digital-gift-card"

        ){
          return;
        } 
    
        if (path === "/collections") {
          window.location = "https://bokksuboutique.com/";
          return;
        }
    
        if (path.startsWith("/collections/") || path.startsWith("/products")) {
          window.location = "https://bokksuboutique.com" + path;
        }
      })();
